import { createAction, props } from '@ngrx/store';

export const selectShop = createAction('[Shop] Select Shop', props<{ shop: any }>());
export const clearShopState = createAction('[Shop] Clear Shop State');
export const getSelectedShop = createAction('[Shop] Get Selected Shop');
export const getStoreList = createAction('[Shop] Get Store List', props<{ userId: string }>());
export const setStoreList = createAction('[Shop] Set Store List', props<{ stores: any[] }>());
export const updateStoreInList = createAction('[Shop] Update Store In List', props<{ updatedStore: any }>());
export const addStoreToList = createAction('[Shop] Add Store To List', props<{ newStore: any }>());
